var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOtherGames(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M503.724 191.083C469.399 192.795 442 221.257 442 256s27.399 63.205 61.724 64.917C509.174 299.978 512 278.208 512 256s-2.826-43.978-8.276-64.917zM256 70c34.743 0 63.205-27.399 64.917-61.724C299.978 2.826 278.208 0 256 0s-43.978 2.826-64.917 8.276C192.795 42.601 221.257 70 256 70zM70 256c0-34.743-27.399-63.205-61.724-64.917C2.826 212.022 0 233.792 0 256s2.826 43.978 8.276 64.917C42.601 319.205 70 290.743 70 256zM256 442c-34.743 0-63.205 27.399-64.917 61.724C212.022 509.174 233.792 512 256 512s43.978-2.826 64.917-8.276C319.205 469.399 290.743 442 256 442zM256 236.598c8.437 0 15.3-6.863 15.3-15.299S264.436 206 256 206s-15.299 6.863-15.299 15.299 6.862 15.299 15.299 15.299zM256 256.598c-13.62 0-24.7 11.081-24.7 24.701S242.38 306 256 306s24.701-11.081 24.701-24.701S269.62 256.598 256 256.598z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 161c-52.383 0-95 42.617-95 95s42.617 95 95 95 95-42.617 95-95-42.617-95-95-95zm0 165c-24.648 0-44.7-20.053-44.7-44.701 0-14.912 7.346-28.132 18.602-36.257-5.713-6.274-9.201-14.609-9.201-23.743C220.701 201.835 236.536 186 256 186s35.3 15.835 35.3 35.299c0 9.134-3.488 17.469-9.201 23.743 11.256 8.125 18.603 21.345 18.603 36.257C300.701 305.947 280.648 326 256 326z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412 256c0-48.041 35.846-87.862 82.195-94.134-12.704-32.169-31.984-61.693-57.176-86.885s-54.717-44.471-86.885-57.176C343.862 64.154 304.041 100 256 100s-87.862-35.846-94.134-82.195C129.697 30.509 100.173 49.789 74.98 74.98c-25.192 25.192-44.471 54.717-57.176 86.885C64.154 168.138 100 207.959 100 256s-35.846 87.862-82.195 94.134c12.704 32.169 31.984 61.693 57.176 86.885s54.717 44.471 86.885 57.176C168.138 447.846 207.959 412 256 412s87.862 35.846 94.134 82.195c32.169-12.704 61.693-31.984 86.885-57.176s44.471-54.717 57.176-86.885C447.846 343.862 412 304.041 412 256zM256 381c-68.925 0-125-56.075-125-125s56.075-125 125-125 125 56.075 125 125-56.075 125-125 125z",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOtherGames);
export default __webpack_public_path__ + "static/media/icon-other-games.46c035f41d4daeb6581b8f05a7676518.svg";
export { ForwardRef as ReactComponent };